<template>
  <el-select
    :value="value"
    :disabled="disabled"
    @change="
      (v) => {
        this.$emit('change', v);
        this.$emit('input', v);
      }
    "
    placeholder="请选择"
    clearable
    filterable
  >
    <el-option
      v-for="item in options"
      :key="item.OrgId"
      :label="item.StaName"
      :value="item.OrgId"
    >
      {{ item.StaName }}
    </el-option>
  </el-select>
</template>
  
  <script>
export default {
  name: "StationSelect",
  props: {
    value: [String, Array],
    disabled: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      let options = [];
      if (this.isShow) {
        this.$store.state.DetectStation.forEach((item) => {
          options.push({
            OrgId: item.Id,
            StaName: item.CompanyName,
          });
        });
      } else {
        this.$store.state.DetectStation.filter().forEach((item) => {
          options.push({
            OrgId: item.Id,
            StaName: item.CompanyName,
          });
        });
      }
      return options;
    },
  },
};
</script>
  
  <style scoped>
.code {
  float: left;
  color: #999;
  font-size: 12px;
  margin-right: 20px;
}
</style>
  